import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { message } from 'antd';

import Modal from './Modal';
import { patchQuestionnary } from '../../actions/asyncActions';
import DriverForm from '../forms/DriverForm';

class DriverModal extends Component {
    render() {
        const { modal, params: { question, project, index }, patchQuestionnary } = this.props;

        return <Modal
            {...modal}
            title={question ? 'Редактировать драйвер' : 'Добавить драйвер'}
            footer={null}>
            <DriverForm
                item={question}
                index={index}
                project={project}
                formAction={patchQuestionnary} />
        </Modal>;
    }
}

export default withAsyncActions(props => ({
    patchQuestionnary: patchQuestionnary
        .withSuccessHandler(({ close }) => {
            message.success('Драйвер успешно сохранен');
            close();
        })
        .withErrorHandler(() => message.error('Не удалось сохранить драйвер'))
        .withOptions({ resetOnUnmount: true })
}))(DriverModal);
